import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const Form = styled.form`
    min-height: 480px;
    display: flex;
    flex-direction: column;
`

export const FormActions = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--chakra-space-6);
    margin-top: auto;
    margin-inline: var(--chakra-space-8);
    padding-top: var(--chakra-space-8);
    border-top: 1px solid var(--chakra-colors-grayscale-100);
`

export const BottomActions = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--chakra-space-6);
    margin-top: auto;
    margin-inline: var(--chakra-space-8);
    padding-top: var(--chakra-space-8);
`
